module.exports = __webpack_public_path__ + "/images/video-presentacion-latam.287c4a6.mp4";